/*
 * A selected combobox option renders its own right-side check, so Mantine's blue
 * fill on the selected row is redundant noise. Clear it to transparent: selected
 * and unselected then differ only by the check, which reads the same across the
 * Select, the MultiSelect, and the raw Combobox the collection picker builds on.
 *
 * The :not(:hover) keeps the hover highlight on an unselected row and lifts this
 * to (0,3,0) specificity so it beats Mantine's (0,2,0) selected rule
 * (.m_… :where([data-combobox-selected])) without !important.
 */
.option[data-combobox-selected]:not(:hover) {
  background-color: transparent;
}
